// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3416":"840ca033","6349":"840ca033"}[chunkId] + ".chunk.css";
};